import { Suspense, lazy, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/header/Navbar";
import Home from "./pages/Home";
const Courses      = lazy(() => import("./pages/Courses"));
const Clinicalprivacy = lazy(() => import("./pages/sub_pages/Clinicalprivacy"));
const Coursedetails   = lazy(() => import("./pages/sub_pages/Coursedetails"));
const Resources    = lazy(() => import("./pages/Resources"));
const Contact      = lazy(() => import("./pages/Contact"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

const AppRouter = () => {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Suspense fallback={<div />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/course/:id" element={<Coursedetails />} />
          <Route path="/Clinical_Privacy_and_PHIPA_Compliance_Foundations" element={<Clinicalprivacy />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRouter;
